import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false);
  const [username, setusername] = useState("");

  const userCheck = localStorage.getItem("userID");

  useEffect(() => {
    async function getUser() {
      try {
        if (!userCheck) {
          const authUser = localStorage.getItem("authUser");
          if (authUser) {
            try {
              const parsed = JSON.parse(authUser);
              if (parsed.FirstName) setusername(parsed.FirstName);
              else if (parsed.username) setusername(parsed.username);
              else if (parsed.displayName) setusername(parsed.displayName);
            } catch (e) {}
          }
          return;
        }
        const response = await fetch(`${process.env.REACT_APP_DEFAULTPATH}user-profile`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userCheck,
          }),
        });
        const data = await response.json();
        if (data && data.user && data.user.FirstName) {
          setusername(data.user.FirstName);
        }
      } catch (err) {
        console.error("ProfileMenu fetch error:", err);
      }
    }
    getUser();
  }, [userCheck]);

  const displayName = username || "Rahul";
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block profile-dropdown-wrapper"
      >
        <DropdownToggle
          className="profile-pill-toggle"
          id="page-header-user-dropdown"
          tag="button"
          aria-expanded={menu}
        >
          <div className="profile-avatar-badge">
            {initial}
          </div>
          <div className="profile-text-group ms-2 d-none d-sm-flex">
            <span className="profile-user-name">{displayName}</span>
            <span className="profile-user-sub">My account</span>
          </div>
          <svg
            className="profile-chevron ms-2"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end modern-profile-menu">
          <DropdownItem tag="a" href="/myprofile">
            <i className="bx bx-user font-size-16 align-middle me-2" />
            {props.t("My Profile")}
          </DropdownItem>
          <DropdownItem tag="a" href="/assetinventory">
            <i className="bx bx-box font-size-16 align-middle me-2" />
            {props.t("Asset Inventory")}  
          </DropdownItem>
          <DropdownItem tag="a" href="/scansettings">
            <i className="bx bx-wrench font-size-16 align-middle me-2" />
            {props.t("Scan Settings")}  
          </DropdownItem>
          <DropdownItem tag="a" href="/subscription">
            <i className="bx bx-wifi font-size-16 align-middle me-2" />
            {props.t("Subscription")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link
            to="/login"
            className="dropdown-item text-danger"
            onClick={() => {
              window.localStorage.clear();
              window.location.reload(false);
              window.location.pathname = "/login";
            }}
          >
            <i className="bx bx-power-off font-size-16 align-middle me-2 text-danger" />
            <span>{props.t("Sign out")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
